(function(){
    'use strict';

    angular
    .module('app')
    .controller('LangController', LangController)
    LangController.$inject = ["UseraltService", "$http","$timeout","$uibModal", "$log", "$document","$sce","ReportDefaultService"];
    function LangController(UseraltService,$http,$timeout,$uibModal, $log, $document,$sce,ReportDefaultService)
    {                         
        var vm = this; 
		//console.log("init lang");
        vm.cambiarIdioma = function(lang_id){
        	UseraltService.setIdioma(lang_id,function(data){
                location.reload();
                return false;
            });
        }

    } 
  
})();